import { buildComponent } from 'src/components/factory'
import { useDatasources } from 'src/hooks/use-datasources'

export const Datasources = buildComponent().withLifecycle(useDatasources)
